var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitoringSimpleValue"},[_c('label',[_vm._t("default")],2),_c('span',{attrs:{"data-status":_vm.status}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }